import wixWindow from 'wix-window'
import wixLocation from 'wix-location'
import wixSeo from 'wix-seo'
import { session } from 'wix-storage'
import { convertToURL } from 'public/crossSiteHandlers.js'
import { sendBI } from 'public/BIModule'
import BI_EVENTS from 'public/BIEvents'

const currentEnv = wixWindow.rendering.env;
let isMobile = false

$w.onReady(function () {
    savePreviousPageURL()

    if (currentEnv === "browser") {
        handleBI();
    }

    isMobile = wixWindow.formFactor === "Mobile";
    if (!isMobile) {
        $w("#searchIcon").onClick(searchButtonClick)
        $w("#inputSearcHeader").onKeyPress(enterKeySearch)
    }
})

const handleBI = () => {
    const { OPEN_PAGE } = BI_EVENTS

    const page_name = wixSeo.title
    const referral_url = session.getItem('previousPageURL')
    const origin = wixLocation.query.origin
    const category = 'blog'

    sendBI(OPEN_PAGE, { page_name, category, referral_url, origin })
}

const savePreviousPageURL = () => {
    session.setItem('previousPageURL', session.getItem('currentPageURL'))
    session.setItem('currentPageURL', wixLocation.url)
}

const slideOptions = {
    "duration": 300,
    "delay": 0,
    "direction": "right"
};

function goToSearchPage(searchTerm) {
    wixLocation.to(`${wixLocation.baseUrl}/search/${convertToURL(searchTerm)}`);
}

const searchButtonClick = (event) => {
    if ($w("#inputSearcHeader").isVisible) {
        $w("#inputSearcHeader").hide("slide", slideOptions);
        $w("#lineSearchInput").hide("slide", slideOptions);
    } else {
        $w("#inputSearcHeader").show("slide", slideOptions);
        $w("#lineSearchInput").show("slide", slideOptions);
        setTimeout(() => {
            $w('#inputSearcHeader').focus();
        }, 350);
    }
    const searchTerm = $w('#inputSearcHeader').value;
    if (!searchTerm) {
        return;
    }
    if (wixLocation.path[2] === 'search') {
        return;
    }
    goToSearchPage(searchTerm);
}

const enterKeySearch = (event) => {
    setTimeout(async () => {
        if (event.key === 'Enter') {
            const searchTerm = $w('#inputSearcHeader').value;
            if (searchTerm) {
                $w("#inputSearcHeader").hide("slide", slideOptions);
                $w("#lineSearchInput").hide("slide", slideOptions);
                $w('#inputSearcHeader').value = '';
                goToSearchPage(searchTerm);
            }
        }
        if (event.key === 'Escape') {
            $w('#inputSearcHeader').hide('slide', slideOptions);
            $w("#lineSearchInput").hide("slide", slideOptions);
        }
    }, 50);
}